export interface Environment {
    name: string
    // antd Tag color
    color: string
}

// Works out which Wallex environment an API endpoint belongs to, so users can see where they are acting
export function environmentOf(url?: string): Environment | null {
    if (!url) return null

    let host: string
    try {
        host = new URL(url).hostname
    } catch {
        return null
    }

    if (host === 'localhost' || host === '127.0.0.1') return { name: 'Local', color: 'default' }
    if (host.endsWith('wallex.ninja')) return { name: 'Dev', color: 'blue' }
    if (host.endsWith('wallex.plus')) return { name: 'UAT', color: 'orange' }
    return null
}

export default class Configuration {
    public static BASE_URL = process.env.REACT_APP_SERVICE_ENDPOINT as string
    // The countries API only allows Wallex origins, so in development it goes through the dev server proxy ("proxy" in package.json)
    public static COUNTRIES_URL = process.env.NODE_ENV === 'development' ? '/api/external/countries' : 'https://direct-nodejs.wallex.asia/api/external/countries'
    public static EDIT_COUNTRY() {
        const editCountry = process.env.REACT_APP_EDIT_COUNTRY as string
        return editCountry === 'TRUE'
    }
    public static ENVIRONMENT() {
        return environmentOf(Configuration.BASE_URL)
    }
}
